import React, {RefObject, useState, useEffect} from "react";
import classNames from "clsx";
import styles from "./VideoPlayer.module.css";
import CaptionsPanel from "./captions/CaptionsPanel";
import {Video} from "src/common/video/models/Video";
import {VideoCaptionTrack, VideoCaption} from "src/common/video/models/VideoCaption";
import EditVideoTab from "src/components/EditVideo";
import VideoMenu from "../../../../common/components/videoMenu/VideoMenu";
import PuiTypography from "../../../../components/elements/PuiTypography";
import PuiMessage from "../../../../components/widgets/PuiMessage";
import {useSelector} from "react-redux";
import {AppState} from "src/root/RootReducer";
import useResponsive from "../../../../common/useResponsive";
import VideoReactions from "./reactions/VideoReactions";

interface VideoPageLiveAreaProps {
  video: Video;
  videoRef: RefObject<HTMLVideoElement>;
  currentVideoTimeMs: number;
  subtitles: VideoCaptionTrack[];
  videoCaptions: VideoCaption[];
  ClickVideo: (event: any) => void;
}

function VideoPlayer({
    video,
    videoRef,
    currentVideoTimeMs,
    subtitles,
    videoCaptions,
    ClickVideo
}: VideoPageLiveAreaProps) {
    const {isDesktop} = useResponsive();

    const {videoOption} = useSelector(
        (state: AppState) => ({
            videoOption: state.exVideo.videoOption
        })
    );

    // ビデオURL
    const sourceUrl = video.sourceUrl;

    const videoDownloadControl = document.getElementById("videoPlayer");

    if (videoDownloadControl) {
        videoDownloadControl.oncontextmenu = function () {
            return false;
        };
    }

    const [msg, setMsg] = React.useState<string>("");

    const closeMsg = () => {
        setMsg("");
    };

    // 再生表示パターン切り替え時に再生時間を保持する
    useEffect(() => {
    // 視聴時間の上書きを防ぐ
        if (videoRef && videoRef.current && currentVideoTimeMs > 0) {
            videoRef.current.currentTime = Math.floor(currentVideoTimeMs / 1000);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, []);

    const [isFullscreen, setIsFullscreen] = useState(false);

    const handleFullscreenChange = () => {
        const isFull = document.fullscreenElement === videoRef.current;
        setIsFullscreen(isFull);
    };


    if (!video) {
        return <div>Loading...</div>;
    }

    return (
        <div className={styles.videoArea}>
            <div className={styles.videoAndReactions}>
                {videoOption.isPlay ? (
                    <video
                        id="videoPlayer"
                        className={classNames(
                            videoRef.current &&
                      videoRef.current.videoWidth / videoRef.current.videoHeight >= 1
                                ? styles.LandscapeVideo
                                : styles.PortraitVideo,
                            !isDesktop && isFullscreen && styles.FullscreenVideo
                        )}
                        controls
                        disablePictureInPicture
                        autoPlay
                        muted={videoOption.isMuted}
                        width="100%"
                        ref={videoRef}
                        key={sourceUrl} // Needed to inform React of source changes.
                        controlsList="nodownload"
                        style={{display: "block"}}
                        onClick={ClickVideo}
                    >
                        <source
                            src={sourceUrl}
                            type="video/mp4"
                        />
                        {subtitles.map(subtitle => (
                            <track
                                key={subtitle.id}
                                kind="subtitles"
                                srcLang={subtitle.srcLang}
                                label={subtitle.label}
                                src={subtitle.src}
                            />
                        ))}
                    </video>
                ) : (
                    <video
                        id="videoPlayer"
                        className={classNames(
                            videoRef.current &&
                      videoRef.current.videoWidth / videoRef.current.videoHeight >= 1
                                ? styles.LandscapeVideo
                                : styles.PortraitVideo,
                            !isDesktop && isFullscreen && styles.FullscreenVideo
                        )}
                        controls
                        disablePictureInPicture
                        muted={videoOption.isMuted}
                        width="100%"
                        ref={videoRef}
                        key={sourceUrl} // Needed to inform React of source changes.
                        controlsList="nodownload"
                        style={{display: "block"}}
                        onClick={ClickVideo}
                    >
                        <source
                            src={sourceUrl}
                            type="video/mp4"
                        />
                        {subtitles.map(subtitle => (
                            <track
                                key={subtitle.id}
                                kind="subtitles"
                                srcLang={subtitle.srcLang}
                                label={subtitle.label}
                                src={subtitle.src}
                            />
                        ))}
                    </video>
                )}
                <VideoReactions
                    reactions={video.reactions}
                    videoId={video.id}
                    videoDuration={video.durationMillis}
                    videoRef={videoRef}
                    video={video}
                />
                {/* ビデオ編集ボタン */}
                <div className={styles.editVideoIcon}>
                    <EditVideoTab video={video}/>
                </div>

                {/* メニューボタン */}
                <div className={styles.menu}>
                    <VideoMenu video={video} setMsg={setMsg}/>
                </div>
            </div>
            <div className={styles.caption}>
                <CaptionsPanel
                    videoId={video.id}
                    captions={videoCaptions}
                    videoRef={videoRef}
                    currentVideoTimeMs={currentVideoTimeMs}
                />
            </div>
            {/* {isAdmin(userInfo?.roles) && (<div className={styles.caption}>
          <CaptionsPanel
            videoId={video.id}
            captions={video.captions}
            videoRef={videoRef}
            currentVideoTimeMs={currentVideoTimeMs}
          />
        </div>)} */}
            <PuiMessage
                open={msg !== ""}
                type="success"
                title="登録に成功しました"
                detail={[<PuiTypography key={msg}>{msg}</PuiTypography>]}
                duration={6000}
                onClose={closeMsg}
            />


        </div>
    );
}

export default VideoPlayer;
